import { API_ROUTES } from "../configuration/RoutesApi"
import { useLoad } from "../context/useLoadContext"
import { ERequestType } from "../Enum/ERequestType"
import {
  addtionalMemory,
  awardMemory,
  categoryMemory,
  comboMemory,
  companyMemory,
  extraServiceMemory,
  noticeMemory,
  productsMemory,
  promotionsMemory,
  selectionMemory,
} from "../Objects/Memory/Memory"
import { converteDateToSql, setDelay } from "../Objects/Generics/Helps"
import { GetRequest } from "../services/ApiClientService"
import { useGetAddtional } from "./Addtional/useGetAddtional"
import { useGetAward } from "./Award/useGetAward"
import { useGetCategory } from "./Category/useGetCategory"
import { useGetCompany } from "./Company/useGetCompany"
import { useGetCustomer } from "./Costumer/useGetCustomer"
import { useGetCourier } from "./Courier/useGetCourier"
import { useGetCombo } from "./Combo/useGetCombo"
import { useGetEmployee } from "./Employee/useGetEmployee"
import { useGetExtraService } from "./ExtraService/useGetExtraService"
import { useGetProducts } from "./Products/useGetProducts"
import { useGetOrder } from "./Order/useGetOrder"
import { useGetPromotions } from "./Promotions/useGetPromotions"
import { useGetServicePoints } from "./ServicePoints/useGetServicePoints"
import { useGetCoupon } from "./Coupon/useGetCoupon"
import { useGetTutorial } from "./Tutorial/useGetTutorial"
import { useGetSelection } from "./Selection/useGetSelection"
import { useGetNotice } from "./Notice/useGetNotice"
import { getStoreNow } from "../utils/timeZone"

let memoryLoaded = false

export const useReloadMemory = () => {
  const { enableLoad, disableLoad, enableFlagLoad, disableFlagLoad } = useLoad()

  const { handleGetEmployee } = useGetEmployee()

  const { handleGetAward } = useGetAward()

  const { handleGetCompany } = useGetCompany()

  const { handleGetCombo } = useGetCombo()

  const { handleGetExtraService } = useGetExtraService()

  const { handleGetProducts } = useGetProducts()

  const { handleGetPromotions } = useGetPromotions()

  const { handleGetAddtional } = useGetAddtional()

  const { handleGetCategory } = useGetCategory()

  const { handleGetCostumer } = useGetCustomer()

  const { handleGetServicePoints } = useGetServicePoints()

  const { handleGetOrder } = useGetOrder()

  const { handleGetCourier } = useGetCourier()

  const { handleGetCoupon } = useGetCoupon()

  const { handleGetTutorial } = useGetTutorial()

  const { handleGetSelection } = useGetSelection()

  const { handleGetNotice } = useGetNotice()

  const handleReloadToMemory = async () => {
    if (memoryLoaded) {
      return
    }

    enableLoad()

    memoryLoaded = true

    await Promise.all([
      handleGetServicePoints(() => {}),
      handleGetCompany(() => {}),
      handleGetEmployee(() => {}),
      handleGetAward(() => {}),
      handleGetPromotions(() => {}),
      handleGetAddtional(() => {}),
      handleGetCategory(() => {}),
      handleGetExtraService(() => {}),
      handleGetProducts(() => {}),
      handleGetCombo(() => {}),
      handleGetCostumer(() => {}),
      handleGetCourier(() => {}),
      handleGetCoupon(() => {}),
      handleGetTutorial(() => {}),
      handleGetSelection(() => {}),
      handleGetNotice(() => {}),
    ])

    memoryLoaded = false

    disableLoad()
  }

  const handleReloadPublicMemory = async (storeSlug: string, onCatalogLoaded?: () => void) => {
    enableLoad()

    const hasCompany = await handleGetCompany(() => {}, API_ROUTES.COMPANY.GET_ALL_PUBLIC(storeSlug), false)

    if (!hasCompany) {
      disableLoad()

      return false
    }

    categoryMemory.setList([])
    addtionalMemory.setList([])
    productsMemory.setList([])
    comboMemory.setList([])
    awardMemory.setList([])
    promotionsMemory.setList([])
    extraServiceMemory.setList([])
    selectionMemory.setList([])
    noticeMemory.setList([])

    const catalogLoading = Promise.all([
      handleGetCategory(() => {}, API_ROUTES.CATEGORY.GET_ALL_PUBLIC(storeSlug)),
      handleGetAddtional(() => {}, API_ROUTES.ADDTIONAL.GET_ALL_PUBLIC(storeSlug)),
      handleGetProducts(
        () => {},
        API_ROUTES.PRODUCT.GET_ALL_PUBLIC(storeSlug),
        false,
      ),
      handleGetCombo(() => {}, API_ROUTES.COMBO.GET_ALL_PUBLIC(storeSlug)),
      handleGetAward(() => {}, API_ROUTES.AWARD.GET_ALL_PUBLIC(storeSlug)),
      handleGetPromotions(() => {}, API_ROUTES.PROMOTION.GET_ALL_PUBLIC(storeSlug)),
      handleGetExtraService(() => {}, API_ROUTES.EXTRA_SERVICE.GET_ALL_PUBLIC(storeSlug)),
      handleGetSelection(() => {}, API_ROUTES.SELECTION.GET_ALL_PUBLIC(storeSlug)),
      handleGetNotice(() => {}, API_ROUTES.NOTICE.GET_ALL_PUBLIC(storeSlug)),
    ])

    disableLoad()

    void catalogLoading.then(() => onCatalogLoaded?.())

    void GetRequest<{ canCreateOrder: boolean }>(
      API_ROUTES.SUBSCRIPTION.PUBLIC_ORDER_AVAILABILITY(storeSlug),
    ).then((availabilityResponse) => {
      if (availabilityResponse.success) {
        companyMemory.canCreatePublicOrder = availabilityResponse.data?.canCreateOrder ?? true
      }
    })

    return true
  }

  const handleReloadPublicOrder = async (storeSlug: string) => {
    enableFlagLoad()

    const endDate = getStoreNow(companyMemory.timeZoneId)

    const startDate = getStoreNow(companyMemory.timeZoneId)

    startDate.setDate(startDate.getDate() - 90)

    await setDelay(500)

    await handleGetOrder(
      () => {},
      converteDateToSql(startDate),
      converteDateToSql(endDate),
      API_ROUTES.ORDER.GET_ALL_PUBLIC(storeSlug),
      ERequestType.Customer,
    )

    disableFlagLoad()
  }

  return {
    handleReloadToMemory,
    handleReloadPublicOrder,
    handleReloadPublicMemory,
  }
}
